import { InMemoryWebStorage } from "oidc-client-ts";

const embeddedLocal = new InMemoryWebStorage();
const embeddedSession = new InMemoryWebStorage();

export const DOCEBO_ENTRY_PATH = "/oauth/auto-login";
const DOCEBO_WINDOW_NAME = "simbel-docebo-widget";

let embedded: boolean | undefined;

/** `window.name` survives the frame's own navigations, so a reloaded Docebo widget stays isolated. */
export function isEmbeddedAuth(): boolean {
  if (typeof window === "undefined") return false;
  if (embedded === undefined) {
    embedded =
      window.self !== window.top &&
      (window.location.pathname === DOCEBO_ENTRY_PATH || window.name === DOCEBO_WINDOW_NAME);
    if (embedded) window.name = DOCEBO_WINDOW_NAME;
  }
  return embedded;
}

export function authLocalStorage(): Storage {
  return isEmbeddedAuth() ? embeddedLocal : window.localStorage;
}

export function authSessionStorage(): Storage {
  return isEmbeddedAuth() ? embeddedSession : window.sessionStorage;
}

export function authEntryPath(): string {
  return isEmbeddedAuth() ? DOCEBO_ENTRY_PATH : "/";
}
